import { useStore } from '../../../store';
import { getExtendedTransactionV2 } from '../../../flows/transactions/utils';
import { LiliTransaction } from '../types/lili-transaction';

export const enrichData = async (transaction: LiliTransaction) => {
  const rootSlice = useStore.getState();
  const { user, getPrimaryAccount } = rootSlice;
  const res = await getExtendedTransactionV2({ activeTransaction: transaction, customerId: user.customerId, accountNo: getPrimaryAccount().achAccountNumber });
  return res;
};
